import {BrickContext, ActionBrick, registerBrick } from 'olympe';
import {getLogger} from "@olympeio/core";

export default class WebSpeechApiSTT extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} language
     * @param {function()} forwardEvent
     * @param {function(boolean)} setIsRecording
     * @param {function(Array)} setTexts
     */
    update($, [language], [forwardEvent, setIsRecording, setTexts]) {

        if ($.get('recognition') === null) {
            $.set('recognition', new webkitSpeechRecognition());
        }


        getLogger('WebSpeechApi').info($.get('is-recording'));
        if($.get('is-recording')) {
            this.stopRecording($, forwardEvent, setIsRecording);
        } else {
            this.startRecording($,language, forwardEvent, setIsRecording, setTexts);
        }

    }

    stopRecording($, forwardEvent, setIsRecording) {
        getLogger('WebSpeechApi').log('Required to stop... ')
        const recognition = $.get('recognition');
        recognition.stop();
        setIsRecording(false);
        forwardEvent();
    }

    startRecording($, language, forwardEvent, setIsRecording, setTexts) {

        const recognition = $.get('recognition');
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = language;

        recognition.onstart = function() {
            getLogger('WebSpeechApi').log('starting the record...')
            $.set('is-recording', true);
            setIsRecording(true);
            forwardEvent();
        };

        recognition.onerror = (event) => {
            if (event.error === 'no-speech') {
                getLogger('WebSpeechApi').error('Error detected: no-speech');
            }
            if (event.error === 'audio-capture') {
                getLogger('WebSpeechApi').error('Error detected: no-microphone');
            }
            if (event.error === 'not-allowed') {
                if (event.timeStamp - start_timestamp < 100) {
                    getLogger('WebSpeechApi').error('Error detected: blocked');
                } else {
                    getLogger('WebSpeechApi').error('Error detected: denied');
                }
            }
        };

        recognition.onend = () => {
            getLogger('WebSpeechApi').log('Stopping the record...')
            $.set('is-recording', false);
            setIsRecording(false);
            forwardEvent();
        };

        const texts = [];
        recognition.onresult = (event) => {

            let partial = '';
            let isFinal = false;
            for (let i = event.resultIndex; i < event.results.length; ++i) {
                if (event.results[i].isFinal) {
                    texts.pop();
                    texts.push(event.results[i][0].transcript);
                    texts.push('');
                    setTexts([...texts]);
                    isFinal = true;
                } else {
                    partial += event.results[i][0].transcript;
                }
            }
            if (!isFinal) {
                texts.pop();
                texts.push(partial);
                setTexts([...texts]);
            }

        };

        recognition.start();
    }
}

registerBrick('0190dede2a75eee04b2c', WebSpeechApiSTT);
